import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import emitter from '@/utility/eventBus';
import HomeView from '../views/HomeView.vue'
import accountRoutes from "./account"; 
import adminRoutes from './admin';
import donationGroupRoutes from './donationGroup';
import sponsorRoutes from './sponsor';
import campaignRoutes from './campaign';
import mypageRoutes from './mypage';
import weddingRoutes from './wedding';
import funeralRoutes from './funeral';
import PaymentView from '@/views/PaymentView.vue';
import customerServiceRoutes from './customerService';
import apiGuideRoutes from './apiGuide';
import apiInvitationRoutes from './apiGuide/index2';
import invitationRoutes from './invitation';
import overViewRoutes from './overview';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/payment',      // temp
    name: 'payment',
    component: PaymentView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  ...accountRoutes,
  ...adminRoutes,
  ...donationGroupRoutes,
  ...sponsorRoutes,
  ...campaignRoutes,
  ...mypageRoutes,
  ...weddingRoutes,
  ...funeralRoutes,
  ...customerServiceRoutes,
  ...apiGuideRoutes,
  ...apiInvitationRoutes,
  ...invitationRoutes,
  ...overViewRoutes
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0, left: 0 };
  },
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      if (!store.state.accountModule.isAuthenticated) {
        await store.dispatch('accountModule/requestCheckLogin');
      }

      if (store.state.accountModule.isAuthenticated) {
        if (to.meta.normalOnly) {
          if (store.state.accountModule.userInfo.roleType === 'NORMAL' || store.state.accountModule.userInfo.roleType === 'ADMIN') {
            next()
          } else {
            emitter.emit('openModal', {
              type: 'alertModal',
              options: {
                message: '일반 회원만 접근 가능합니다.',
              },
            });
            if (from.name === 'MyPage') {
              next(false);
            } else {
              next({ name: 'MyPage' })
            }
          }
        } else {
          next()
        }
        next()
      } else {
        const confirmed = await new Promise((resolve) => {
          emitter.emit('openModal', {
            type: 'confirmModal',
            options: {
              message: '로그인이 필요합니다. 로그인 페이지로 이동하시겠습니까?',
              callback: resolve,
            },
          });
        });

        if (confirmed) {
          next({ name: 'AccountLoginPage' });
        } else {
          next(false);
        }
      }
    } catch (err) {
      console.error('로그인 체크 오류:', err);
      next({ name: 'AccountLoginPage' });
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: to.fullPath,
    page_title: document.title,
    prev_page_path: from.fullPath || null
  });
});



export default router
